import React from "react";
import { useFormContext, Controller } from "react-hook-form";
import PI, { PhoneInputProps } from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import "./Form.css";
import { TextCss } from "../../components/GlobalCss/TextCss";
import { useError } from "../../utils/context/ErrorContext";
import { validatePhone } from "../../utils/validateHelper";

// Workaround for react-phone-input-2 import issues
const ReactPhoneInput: React.FC<PhoneInputProps> = (PI as any).default || PI;

interface CustomPhoneInputProps {
  name: string;
  label?: string;
  required?: boolean;
  requiredMessage?: string;
  disabled?: boolean;
  className?: string;
  placeholder?: string;
  defaultCountry?: string;
  sectionName?: string;
  inputIndex?: number;
}

const PhoneInput: React.FC<CustomPhoneInputProps> = ({
  label = "Phone Number",
  name,
  required = false,
  requiredMessage = "This field is required",
  disabled = false,
  className = "",
  placeholder = "Enter Contact Number",
  defaultCountry = "us",
  sectionName = "",
  inputIndex = undefined,
}) => {

  const {
    control,
    formState: { errors, isSubmitted },
  } = useFormContext();
  const { setErrors, setErrorMessages, errors: contextErrors, errorMessages: contextErrorMessages } = useError();

  const errorKey = sectionName ? `${sectionName}.${name}` : inputIndex !== undefined ? `${name}[${inputIndex}]` : name;
  const contextError = contextErrors[errorKey];
  const contextErrorMessage = contextErrorMessages[errorKey];

  const error = errors[name];

  return (
    <div className={`form-group ${className}`}>
      {label && (
        <label className={TextCss.black.sub_heading_600_14}>
          {label} {required && <span className="text-danger">*</span>}
        </label>
      )}

      <Controller
        name={name}
        control={control}
        rules={{
          required: required ? requiredMessage : false,
          validate: (value) => {
            if (!value && !required) return true;
            const isValid = validatePhone(
              value,
              defaultCountry,
              () => {}, // dummy setErrors
              () => {}, // dummy setErrorMessages
              sectionName,
              inputIndex
            );
            return isValid || "Please enter a valid US phone number";
          },
        }}
        render={({ field: { onChange, value, onBlur } }) => {
          const showErrorMessage = (isSubmitted || error || contextError) && (error || contextError);

          return (
            <>
              <ReactPhoneInput
                country={defaultCountry?.toLowerCase() || "us"}
                value={value}
                onChange={(phone, country) => {
                  onChange(phone);
                  validatePhone(
                    phone,
                    country,
                    setErrors,
                    setErrorMessages,
                    sectionName,
                    inputIndex
                  );
                }}
                onBlur={onBlur}
                disabled={disabled}
                placeholder={placeholder}
                disableDropdown={true}
                onlyCountries={["us"]}
                containerClass="phone-input-container"
                inputClass={`form-control form-control-phone ${showErrorMessage ? "is-invalid" : ""}`}
                inputStyle={{
                  width: "100%",
                }}
                buttonStyle={{
                  border: "none",
                  backgroundColor: "transparent",
                }}
              />
              {showErrorMessage && (
                <div className="invalid-feedback" style={{ display: "block" }}>
                  {(error?.message as string) || contextErrorMessage}
                </div>
              )}
            </>
          );
        }}
      />
    </div>
  );
};

export default PhoneInput;
